
class MenuItemImage {
    getImageUrl = () => {
        return (window.appSetting && window.appSetting.resource_use_storage_url && this.storage_url) || this.image_path
    }
}

export default MenuItemImage